const calculateTotalPeriods = (
  vesting: number,
  consolidation: number
): number => Math.ceil(+vesting / +consolidation);

export default calculateTotalPeriods;
